module.exports = __webpack_public_path__ + "assets/alarmas.96ce2b27a5b9d6bad9da7a5440d179ee.svg";


//////////////////
// WEBPACK FOOTER
// ./img/alarmas.svg
// module id = 647
// module chunks = 0